<template>
    <v-container>
        <v-card 
            flat
            height='100%'
        >
            <!-- Add structural frame -->
            <v-data-table
                :headers="structHeaders"
                :items="structRows"
                sort-by='subCategory'
                item-key='fullName'
                v-model='selected'
                single-select
                show-select
            >
                <template v-slot:top>
                    <v-toolbar flat color='primary'>
                        <v-dialog v-model='dialog' width='60%'>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="secondary"
                                    dark
                                    class="mb-2 mx-2"
                                    v-bind="attrs"
                                    v-on="on"
                                >Add Structure</v-btn>
                            </template>
                            <v-card>
                                <v-card-title>New {{ structItem.subCategory }}</v-card-title>
                                <v-container>
                                    <v-row class='my-2 mx-2'>
                                        <v-col cols='12' md='6'>
                                            <!-- select system type -->
                                            <v-autocomplete
                                                label='Select Type'
                                                color='secondary'
                                                item-color='secondary'
                                                outlined
                                                :items='structTypes'
                                                v-model='structItem.subCategory'
                                            
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols='12' md='6'>
                                            <!-- select region -->
                                            <v-autocomplete
                                                label='Region'
                                                color='secondary'
                                                item-color='secondary'
                                                outlined
                                                :items='regions'
                                                v-model='structItem.region'
                                            
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols='12' md='12'>
                                            <!-- select system, filtered by type -->
                                            <v-autocomplete
                                                name='SuperSelect'
                                                label="Select System"
                                                color='secondary'
                                                item-color='secondary'
                                                outlined
                                                :items='structFilter.structFilter.names'
                                                v-model='structItem.fullName'
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols='12' md='4'>
                                            <v-text-field
                                                readonly
                                                outlined
                                                color='secondary'
                                                :label='selectedCarbon.type.units'
                                                :value='selectedCarbon.type.carbon'
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols='12' md='4'>
                                            <v-text-field
                            
                                                outlined
                                                color='secondary'
                                                label="Quantity"
                                                v-model='structItem.quant'
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols='12' md='4'>
                                            <v-text-field
                                                readonly
                                                outlined
                                                color='secondary'
                                                label="kgCO2e"
                                                :value='carbonContribution.item.carbon'
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn 
                                        color='secondary lighten 2'
                                        @click='addFrame'
                                    >
                                        Add
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                
            </v-data-table>
        </v-card>
        <v-row class='align-center'>
            <v-col cols='12' sm='12' md='6'>
                <v-card flat>
                    <v-card-actions>
                        <v-btn
                            class='mx-2'
                            color='secondary'
                            @click="saveStruct"
                        >
                            Save
                        </v-btn>
                        <v-btn
                            class='mx-2'
                            color='info'
                            @click="deleteItem"
                        >
                            Delete
                        </v-btn>
                        <v-btn
                            class='mx-2'
                            color='error'
                            @click='clearRows'
                        >
                            Clear
                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-col>
            <v-col cols='6' sm='12' md='6'>
                <v-card flat>
                    <v-card-text class='text-end'>
                        <p>
                            Total Structural Carbon: <strong>{{ structTotal }} tCO<sub>2</sub></strong> 
                        </p>
                        <p>
                            Structural Carbon Instensity: <strong>{{ structInt }} kgCO<sub>2</sub>e/m<sup>2</sup></strong>
                        </p> 
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
    </v-container>
</template>

<script>


export default {
    props: {
        items: Array,
        gia: Number,
    },

    components: {  },

    data () {

        
        return {
            dialog: false,
            dialog2: false,

            selected: [],

            structTypes: [
                'Frame',
                'Core',
                'Substructure',
                'Foundation',
            ],

            regions: [
                'UK',
            ],

            structHeaders: [
                { text: 'Type', value: 'subCategory'},
                { text: 'System', value: 'fullName' },
                { text: 'Carbon Intensity', value: 'totalCarbon'},
                { text: 'Quantity', value: 'quant'},
                { text: 'Carbon (kgCO2)', value: 'absCarbon'}

            ],


            structItem: {
                fullName: '',
                subCategory: '',
                units: '',
                totalCarbon: 0,
                quant: 0,
                absCarbon: 0,
                region: '',
            },

            defaultItem: {
                fullName: '',
                subCategory: '',
                units: '',
                totalCarbon: 0,
                quant: 0,
                absCarbon: 0,
                region: ''
            },
            
            structRows: [],

            structOutput: {
                'Frame': 0,
                'Core': 0,
                'Basement': 0,
                'Total': 0
            },

            structTotal: 0,
            structInt: 0,

            chartData: { 
                columns: ['type', 'carbon'],
                rows: []
            }
            
        }
    },

    watch:{
        'gia': {
            handler: function() {
                if ( this.gia < 1 ) {
                    this.gia = 1
                }
            },
            deep: true
        },


        // whenever structItem changes this function will run
        'structItem': {
            handler: function() {
                var name = this.structItem.fullName
                var quant = Number(this.structItem.quant)

                var carbon = 0
                var typ_array = this.items

                // search cards for relevant and add data
                for (var i=0; i < typ_array.length; i++) {
                    if (name == typ_array[i].fullName) {
                        carbon = Number(typ_array[i].totalCarbon)

                    }
                }

                // update values in structItem ready to be added to rows
                this.structItem.totalCarbon = Math.round(10*carbon)/10
                this.structItem.absCarbon = Math.round(quant * carbon)                
            },
            deep: true
        },

        // when structRows updates, update totals
        'structRows': {
            handler: function() {
                const structure = this.structRows
                                
                // reset structOutput
                this.structOutput = {
                    'Frame': 0,
                    'Core': 0,
                    'Basement': 0,
                    'Total': 0
                }

                for (var i=0; i < structure.length; i++) {
                    var row = structure[i]

                    var absCarbon = Number(row['absCarbon'])
                    var subCat = row['subCategory']

                    this.structOutput[subCat] += Math.round(10*(absCarbon) / 1000)/10
                    this.structOutput['Total'] += Math.round(10*(absCarbon) / 1000)/10
                }

                this.structTotal = Math.round(10*this.structOutput['Total'])/10
                this.structInt = Math.round(10*(this.structTotal / this.gia)*1000)/10

                //console.log(this.structOutput)
                // push output up to CalculatorMain

                // create chart data
                // const gia = this.gia

            },
            deep: true
        },

    },

    computed: {
        // filter options based on selected type
        structFilter () {
            const struct_data = []
            const struct_names = []
            var typ_array = this.items
            var typ_length = typ_array.length
            var itemType = this.structItem.subCategory
            var itemRegion = this.structItem.region

            for (var i=0; i < typ_length; i++ ) {
                var cat1 = typ_array[i].category
                var cat2 = typ_array[i].subCategory
                var cat3 = typ_array[i].region

                if (cat1 == 'Structure' && cat2 == itemType && cat3 == itemRegion) {
                    // add object with amended name
                    typ_array[i].fullName = typ_array[i].name + " - " + typ_array[i].subtitle + " (" + typ_array[i].region + ") - "  + typ_array[i].units 
                    struct_data.push(typ_array[i]);
                    // add list of names for dropdown
                    var fullName = typ_array[i].fullName
                    struct_names.push(fullName)
                }
            }
            return { 
                structFilter: { names: struct_names, objects: struct_data }
            }
        },

        selectedCarbon () {
            var selectedTypeName = this.structItem.fullName
            var types = this.items

            for (var i=0; i < types.length; i++) {
                if ( types[i].fullName == selectedTypeName) {
                    var typeCategory = types[i].subCategory
                    var typeCarbon = Number(types[i].totalCarbon)
                    var units = types[i].units
                }
                
            }

            return {
                type: { category: typeCategory, carbon: typeCarbon, units: units}
            }

        },

        carbonContribution () {
            var carbon = 0
            var carbonIntensity = Number(this.structItem.totalCarbon)
            var quant = Number(this.structItem.quant)

            if (carbonIntensity && quant > 0) {
                 carbon = carbonIntensity * quant
            }

            return {
                item: { carbon: carbon }
            }
        },

        

    },        


    methods: {
        close () {
            this.dialog = false
            this.$nextTick(() => {
                this.structItem = Object.assign({}, this.defaultItem)
            })
        },

        addFrame () {
            
            this.structRows.push(this.structItem)
            this.close()
        },

        deleteItem () {
            if(confirm('Are you sure you want to delete this item?')){
                for(var i = 0; i <this.selected.length; i++){
                    const index = this.structRows.indexOf(this.selected[i]);
                    this.structRows.splice(index, 1);
                }
            }

            //const index = this.structRows.indexOf(item)
            // confirm('Are you sure you want to delete this row?') && this.structRows.splice(index, 1)
        },

        saveStruct () {

            var structOut = this.structRows

            this.$emit('struct-out', structOut)
        },

        clearRows () {
            return this.structRows = []
            
        }




    }
}
</script>